/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { CarouselItem } from '@shared/types';
import { CDN_URLS, OCI_FOLDERS } from '../config';

export const carouselItems: CarouselItem[] = [
    {
        id: 'fruling-elegance',
        titleKey: 'carousel_fruling_elegance',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/fruling_10.png`, //`${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/the-winter-of-warmth-fashion-color-trends`,
        source: 'blog'
    }, // Row 1
    {
        id: 'winter-elegance',
        titleKey: 'carousel_winter_elegance',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/city_herbst_blau_elegance.png`, //`${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/the-winter-of-warmth-fashion-color-trends`,
        source: 'blog'
    },
    {
        id: 'fruling-casual',
        titleKey: 'carousel_fruling_casual',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/fruling_129.png`, //`${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/the-winter-of-warmth-fashion-color-trends`,
        source: 'blog'
    },
    {
        id: 'fruling-elegant',
        titleKey: 'carousel_fruling_elegant',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/fruling_155.png`, //`${CDN_URLS.UNSPLASH}photo-1483985988355-763728e1935b?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/the-winter-of-warmth-fashion-color-trends`,
        source: 'blog'
    },
    // Row 2
    {
        id: 'spring-elegance',
        titleKey: 'carousel_spring_elegance',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.HOMEPAGE}download (32).png`,
        link: `${CDN_URLS.BLOG}/2026/01/11/spring-elegance-texture-movement-and-coastal-vibes`,
        source: 'blog'
    },
    {
        id: 'minimalist-wardrobe',
        titleKey: 'carousel_minimalist_wardrobe',
        category: 'Style Guide',
        imageUrl: `${CDN_URLS.UNSPLASH}photo-1490481651871-ab68de25d43d?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/business-simplicity-the-smart-casual-bridge`,
        source: 'blog'
    },
    {
        id: 'wardrobe-casual',
        titleKey: 'carousel_wardrobe_casual',
        category: 'Style Guide',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Casual/fruling_192.png`, //`${CDN_URLS.UNSPLASH}photo-1490481651871-ab68de25d43d?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/business-simplicity-the-smart-casual-bridge`,
        source: 'blog'
    },
    {
        id: 'power-dressing',
        titleKey: 'carousel_power_dressing',
        category: 'Outfits',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/christmas_red_elegance.png`, //`${CDN_URLS.UNSPLASH}photo-1487412720507-e7ab37603c6f?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/power-dressing-the-soft-power-revolution`,
        source: 'blog'
    },
    {
        id: 'spring-trends-elegance',
        titleKey: 'carousel_spring_trends',
        category: 'Trends',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_6.png`, //`${CDN_URLS.UNSPLASH}photo-1515886657613-9f3515b0c78f?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/spring-elegance-texture-movement-and-coastal-vibes`,
        source: 'blog'
    },
    {
        id: 'spring-trends-texture',
        titleKey: 'carousel_spring_trends',
        category: 'Trends',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Sport/sport_444.jpg`,
        link: `${CDN_URLS.BLOG}/2026/01/11/spring-elegance-texture-movement-and-coastal-vibes`,
        source: 'blog'
    },
    {
        id: 'power-dressing-elegance',
        titleKey: 'carousel_power_dressing',
        category: 'Outfits',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/city_herbst_blau_elegance.png`,
        link: `${CDN_URLS.BLOG}/2026/01/11/power-dressing-the-soft-power-revolution`,
        source: 'blog'
    },
    {
        id: 'casual-power-dressing',
        titleKey: 'carousel_power_dressing',
        category: 'Outfits',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}portrait/portret_black_new.png`, //`${CDN_URLS.UNSPLASH}photo-1487412720507-e7ab37603c6f?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/power-dressing-the-soft-power-revolution`,
        source: 'blog'
    },
    // Row 2
    {
        id: 'lifestyle-fashion',
        titleKey: 'carousel_power_dressing',
        category: 'Lifestyle',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_braun_lobby.png`, //`${CDN_URLS.UNSPLASH}photo-1445205170230-053b83016050?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/03/the-winter-of-warmth-fashion-color-trends/`,
        source: 'blog'
    },
    {
        id: 'sustainable-fashion-elegance',
        titleKey: 'carousel_sustainable_fashion',
        category: 'Lifestyle',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}city/bussines_grau_zurich.png`, //`${CDN_URLS.UNSPLASH}photo-1445205170230-053b83016050?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/04/the-new-era-of-fashion-intentional-expressive-and-tech-infused`,
        source: 'blog'
    },
    {
        id: 'accessory-edit',
        titleKey: 'carousel_accessory_edit',
        category: 'Manner',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}manner/manner_elegant_4.png`, //`${CDN_URLS.UNSPLASH}photo-1506630448388-4e683c67ddb0?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/07/the-resort-fashion-view-textures-prints-and-timeless-classics`,
        source: 'blog'
    },
    {
        id: 'accessory-edit-elegance',
        titleKey: 'carousel_spring_elegance',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Elegant/elegant_blue_sommer.png`, //CDN_URLSo-1506630448388-4e683c67ddb0?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/power-dressing-the-soft-power-revolution`,
        source: 'blog'
    },
    {
        id: 'sport-edit-elegance',
        titleKey: 'carousel_sport_edit',
        category: 'Sport',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Sport/sport_ski.png`, //`${CDN_URLS.UNSPLASH}photo-1506630448388-4e683c67ddb0?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/accessory-use-from-afterthought-to-architecture`,
        source: 'blog'
    },
    {
        id: 'winter-edit-elegance',
        titleKey: 'carousel_winter_elegance',
        category: 'Seasonal',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}seasonal/Winter/winter_elegance.png`, //`${CDN_URLS.UNSPLASH}photo-1506630448388-4e683c67ddb0?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/spring-elegance-texture-movement-and-coastal-vibes`,
        source: 'blog'
    },
    {
        id: 'winter-edit',
        titleKey: 'carousel_winter_elegance',
        category: 'Seasonal',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}seasonal/Winter/winter_5.png`, //`${CDN_URLS.UNSPLASH}photo-1506630448388-4e683c67ddb0?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/winter-elegance-the-art-of-the-layer/`,
        source: 'blog'
    },
    {
        id: 'auto-edit',
        titleKey: 'carousel_auto_edit',
        category: 'Seasonal',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}Autos/Auto_red_1.jpg`, //`${CDN_URLS.UNSPLASH}photo-1506630448388-4e683c67ddb0?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/the-spring-2026-trend-report-optimism-texture-and-the-new-bold`,
        source: 'blog'
    },

    {
        id: 'evening-glamour',
        titleKey: 'carousel_evening_glamour',
        category: 'Fashion',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}city/schwarz_el_bern.png`, //`${CDN_URLS.UNSPLASH}photo-1539008835657-9e8e9680c956?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/evening-glamour-the-new-nocturnal-aesthetic`,
        source: 'blog'
    },
    {
        id: 'travel-essentials',
        titleKey: 'carousel_travel_essentials',
        category: 'Travel',
        imageUrl: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}portrait/sport_portrait.jpg`, //`${CDN_URLS.UNSPLASH}photo-1469334031218-e382a71b716b?w=800&auto=format&fit=crop`,
        link: `${CDN_URLS.BLOG}/2026/01/11/business-efficiency-the-uniform-method-for-the-modern-leader`,
        source: 'blog'
    },
];

/**
 * Fetches Instagram reels and converts them to carousel format
 */
export const fetchInstagramCarouselItems = async (): Promise<CarouselItem[]> => {
    try {
        // Import dynamically to avoid circular dependencies
        const { fetchInstagramReels } = await import('@shared/services/socialMediaService');
        const reels = await fetchInstagramReels();

        return reels.slice(0, 4).map((reel) => ({
            id: `instagram-${reel.id}`,
            titleKey: reel.caption || 'carousel_instagram_reel',
            category: 'Instagram',
            imageUrl: reel.thumbnailUrl,
            link: reel.videoUrl,
            source: 'instagram' as const
        }));
    } catch (error) {
        console.error('Failed to fetch Instagram carousel items:', error);
        return [];
    }
};

/**
 * Gets all carousel items including Instagram reels
 */
export const getAllCarouselItems = async (): Promise<CarouselItem[]> => {
    const instagramItems = await fetchInstagramCarouselItems();
    return [...carouselItems, ...instagramItems];
};
